import { createSlice } from "@reduxjs/toolkit";
import { thunks } from "src/thunks/assets";

const assetsState = {
  items: [],
  itemsLoading: false,
  filesUploading: false,

  // Single Folder / Item Delete
  itemDeleting: false,

  // Multiple Items Delete
  multipleItemsDeleting: false,

  // Upload Items Errors (Folder Restrictions/Validations)
  filesUploadErrors: null,

  // Close Add Item Modal
  closeAddItemModal: false,

  // Close Delete Item Modal
  closeDeleteItemModal: false,

  // Close Delete Multiple Selected Items Modal
  closeDeleteMultipleSelectedItemsModal: false,

  // Spaces Api History Log
  spacesApiHistoryLog: [],
  spacesApiHistoryLogLoading: false,
};

const reducers = {
  setItems(state, action) {
    state.items = action.payload;
  },
  setItemsLoading(state, action) {
    state.itemsLoading = action.payload;
  },
  setFilesUploading(state, action) {
    state.filesUploading = action.payload;
  },
  // Single Folder / Item Deleting
  setItemDeleting(state, action) {
    state.itemDeleting = action.payload;
  },
  // Multiple Items Deleting
  setMultipleItemsDeleting(state, action) {
    state.multipleItemsDeleting = action.payload;
  },
  // Reset Files Upload Errors
  uploadFilesErrorsReset(state, action) {
    state.filesUploadErrors = null;
  },
  // Reset Close Add Item Modal
  closeAddItemModalReset(state, action) {
    state.closeAddItemModal = false;
  },
  // Close Delete Item Modal
  deleteItemModalReset(state, action) {
    state.closeDeleteItemModal = true;
  },
  // Reset Close Delete Multiple Selected Items Modal
  closeDeleteItemModalReset(state, action) {
    state.closeDeleteItemModal = false;
  },
  // Close Delete Multiple Selected Items Modal
  deleteMultipleSelectedItemsModalReset(state, action) {
    state.closeDeleteMultipleSelectedItemsModal = true;
  },
  // Reset Close Delete Multiple Selected Items Modal
  closeDeleteMultipleSelectedItemsModalReset(state, action) {
    state.closeDeleteMultipleSelectedItemsModal = false;
  },
  // Get Spaces Api History Log
  spacesApiHistoryLogLoading(state) {
    if (!state.spacesApiHistoryLogLoading) {
      state.spacesApiHistoryLogLoading = true;
    }
  },
  spacesApiHistoryLogReceived(state, action) {
    if (state.spacesApiHistoryLogLoading) {
      state.spacesApiHistoryLogLoading = false;
      state.spacesApiHistoryLog = action.payload;
    }
  },
};

const extraReducers = {
  // Upload Files
  [thunks.uploadFiles.pending]: (state, action) => {
    state.filesUploading = true;
  },
  [thunks.uploadFiles.fulfilled]: (state, action) => {
    state.filesUploading = false;
    state.closeAddItemModal = true;
  },
  [thunks.uploadFiles.rejected]: (state, action) => {
    state.filesUploading = false;
    state.filesUploadErrors = action.payload.error.details;
  },
};

export const slice = createSlice({
  name: "assets",
  initialState: assetsState,
  reducers,
  extraReducers,
});

export const { reducer } = slice;
